/**
 * Подпись задачи в списках: название, иначе номер сборника, иначе запасной текст.
 * @param {{ title?: string|null, source_number?: string|number|null }} task
 * @param {{ fallback?: string }} [opts]
 */
export function taskListLabel(task, opts = {}) {
  const title = typeof task?.title === 'string' ? task.title.trim() : '';
  if (title) return title;
  const n = task?.source_number;
  if (n != null && String(n).trim() !== '') return `№ ${String(n).trim()}`;
  return opts.fallback ?? 'Задача';
}

/**
 * Подпись пункта повестки / черновика ДЗ (title + source_number на самом item).
 */
export function agendaItemLabel(item, opts = {}) {
  return taskListLabel(
    {
      title: item?.title,
      source_number: item?.source_number,
    },
    {
      fallback: opts.fallback
        ?? (item?.task_id != null ? `Задача #${item.task_id}` : 'Задача'),
    },
  );
}
